import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { ICON } from '@core/util/icon';

@Component({
	selector: 'app-profile-benefits',
	templateUrl: './benefits.component.html',
	changeDetection: ChangeDetectionStrategy.OnPush,
	standalone: false,
})
export class ProfileBenefitsComponent {
	@Input() benefits: string[];
	@Input() shouldDisplayDivider = true;
	public ICON = ICON;
}
